import { Box, Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CustomButton } from "../common/button/customButton";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";

const UnauthenticatedHeader: React.FC = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  return (
    <Flex
      justify="flex-end"
      alignItems="center"
      w="100%"
      height="66px"
      px="24px"
    >
      
      <Flex gap="12px" alignItems="center">
     
        <Box data-tour-item="header-pledge-login">
          <CustomButton
            text={t("unauthenticated.pledgeHeader")}
            borderRadius={"8px"}
            border={"1px solid #1819B4"}
            width="fit-content"
            fontSize="14px"
            color="#1819B4"
            fontWeight={500}
            height={"34px"}
            onClick={() => navigate(ROUTE_NAMES.PLEDGE_LOGIN)}
            background="transparent"
            _hover={{ background: "transparent" }}
          />
        </Box>
        <Box data-tour-item="header-signup">
          <CustomButton
            text={t("unauthenticated.signup")}
            borderRadius={"8px"}
            border={"1px solid #1819B4"}
            width="fit-content"
            fontSize="14px"
            color="#1819B4"
            fontWeight={500}
            height={"34px"}
            onClick={() => navigate(ROUTE_NAMES.SINGUP)}
            background="transparent"
            _hover={{ background: "transparent" }}
          />
        </Box>
        <Box data-tour-item="header-journalist-login">
          <CustomButton
            text={t("unauthenticated.login")}
            borderRadius={"8px"}
            border={"1px solid #1819B4"}
            width="fit-content"
            fontSize="14px"
            fontWeight={500}
            height={"34px"}
            onClick={() => navigate(ROUTE_NAMES.LOGIN)}
            background="#1819B4"
            _hover={{ background: "#1819B4" }}
          />
        </Box>
      </Flex>
    </Flex>
  );
};

export default UnauthenticatedHeader;
